<template>
  <div
    class="modal"
    tabindex="-1"
    :id="id"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-ice">
        <div class="modal-header bg-cosmos p-3">
          <span>{{ headerText }}</span>
          <modal-close-button @confirmed="onCancel" />
        </div>
        <div class="modal-body">
          <div
            class="row"
            v-if="text !== null"
          >
            <p v-html="replaceWithBr()"></p>
          </div>
          <div
            class="row pos-r"
            v-if="showTextarea"
          >
            <div class="col-12 form-group">
              <textarea
                v-model="textareaLocal"
                class="form-control"
                :placeholder="textareaPlaceholder"
                rows="4"
              ></textarea>
              <label v-if="textareaLabel">{{ textareaLabel }}</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row w-100">
            <div class="col-12 text-center">
              <button
                v-show="cancel"
                type="button"
                class="btn btn-danger mr-3"
                data-dismiss="modal"
                @click="onCancel"
              >
                <span class="font-khand font-weight-bold">
                  {{ cancelText }}
                </span>
              </button>
              <button
                v-show="ok"
                type="button"
                class="btn btn-success"
                @click="onOk"
              >
                <span class="font-khand font-weight-bold">{{ okText }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { modal } from '@/mixins/Modal'
  import ModalCloseButton from '@/components/global/ModalCloseButton'

  export default {
    name: 'InputModal',
    components: {
      ModalCloseButton,
    },
    props: {
      headerText: {
        type: String,
        default: 'Eingabe',
      },
      text: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: 'input-modal',
      },
      showTextarea: {
        type: Boolean,
        default: false,
      },
      textareaValue: {
        type: String,
        default: '',
      },
      textareaPlaceholder: {
        type: String,
        default: '',
      },
      textareaLabel: {
        type: String,
        default: '',
      },
      ok: {
        type: Boolean,
        default: false,
      },
      cancel: {
        type: Boolean,
        default: true,
      },
      okText: {
        type: String,
        default: 'OK',
      },
      cancelText: {
        type: String,
        default: 'Abbrechen',
      },
      repeatText: {
        type: String,
        default: 'Wiederholen',
      },
    },
    data() {
      return {
        textareaLocal: this.textareaValue || '',
      }
    },
    mixins: [modal],
    watch: {
      textareaValue(newVal) {
        this.textareaLocal = newVal || ''
      },
    },
    methods: {
      replaceWithBr() {
        return this.text ? this.text.replace(/\n/g, '<br />') : ''
      },
      onOk() {
        this.$emit('ok', this.textareaLocal)
        this.closeModal()
      },
      onCancel() {
        this.closeModal()
        this.textareaValue = ''
        this.$emit('cancel')
      },
    },
  }
</script>
